import dayjs from "dayjs";

export const toDateTimeString = (timestamp: number) => {
  const date = dayjs(timestamp);

  return date.format('DD.MM.YY HH:mm')
};
